export { default } from "./accordion-item-header";
